<template>
  <!--悬浮小广告样式的提示信息-->
  <div
      id="qrCodeWrapper"
      ref="qrCodeWrapper"
      :class="pos=='left'?'leftImg':'rightImg'"
      v-show="isShow"
  >
    <div v-show="isShow && pos=='left' " class="closeBtn el-icon-circle-close " @click="close">
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Qrfloat',
  data() {
    return {
      isShow: true
    };
  },
  props: ['pos'],
  mounted() {

  },

  methods: {
    close() {
      this.isShow = false;
    }
  },
};
</script>

<style scoped>
#qrCodeWrapper {
  z-index: 100;
  position: fixed;
  top: 300px;
  right: 30px;
  width: 110px;
  background-color: rgba(255, 255, 255, 0.1);

  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.leftImg {
  left: 30px;
  padding-top: 30px;
}

.closeBtn {
  display: block;
  position: absolute;
  height: 10px;
  top: 0px;
  font-size: 14px;
  right: 0px;
  line-height: 15px;
  color: black;
}

.closeBtn:hover {
  color: red;
  font-size: 18px;
  font-weight: 700;
}

.rightImg {
  right: 30px;
}

#qrCodeWrapper span {
  margin-top: 5px;
  display: flex;
  justify-content: center;
  width: 110px;
  text-align: center;
  font-weight: bolder;
  font-size: 14px;
  color: #c30d23;
}

#qrCodeWrapper img {
  width: 100px;
  height: 100px;
}


</style>
